import axiosIns from "@/libs/axios";

export function requestLoadListings(reqData) {
  return axiosIns.post("/admin/list_listings", reqData, {});
}
